'use client';

import { VpButton } from '@vtmn-play/react/headless';
import classNames from 'classnames';
import { useTranslations } from 'next-intl';
import { useAuthenticatedContext } from '@/app/components/Provider';
import { Link } from '@/i18n/routing';
import { OptionsStatusValueType } from '~/components/Projects/model';
import { isAuthenticatedAsMainUser } from '~/utils/user/user';

export const AboutAction = ({
  isStyleInverse = false,
}: {
  isStyleInverse?: boolean;
}) => {
  const t = useTranslations('ABOUT.ACTIONS');
  const { user, isAuthenticated, redirectToLogin } = useAuthenticatedContext();

  return (
    <>
      {isAuthenticatedAsMainUser(user, isAuthenticated)
        ? (
            <Link
              className={classNames('button-wrapper-link vp-button', {
                'vp-button--inverse': isStyleInverse,
              })}
              href={`/projects?status=${OptionsStatusValueType.all}`}
              prefetch={false}
              passHref
            >
              <span className="vp-button__label" data-part="label">
                {t('SEE_PROJECTS')}
              </span>
            </Link>
          )
        : (
            <VpButton
              onClick={async () => await redirectToLogin()}
              {...(isStyleInverse && { variantStyle: 'inverse' })}
            >
              {t('SIGN_UP')}
            </VpButton>
          )}
    </>
  );
};
